import { createTheme } from '@mui/material';

import { lightPalette } from './palette';

/**
 * Light theme
 * Combines palette, typography, and component styles
 */
export const lightTheme = createTheme({
  palette: lightPalette,
});
